module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"category":"Category","createSpreadsheetParagraph":"Create spreadsheet paragraph","intro":"Intro","keyFacts":"Key facts","laptops":"Laptops","modifier":"Modifier","outro":"Outro","sections":"Sections","site":"Site","spreadsheetParagraphCreated":"Sreadsheet paragraph created","text":"Text","topic":"Topic"}}')
  delete Component.options._Ctor
}
